import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Style from '../../styles/MVPDSSO.module.scss';

const MVPDSSO = ({ isActive, openOverlay, backgroundInline, sharedTheme }) => {
  if (!isActive) return null;
  const innerContainerStyle = backgroundInline ? { ...backgroundInline } : {};
  const {
    previewPass_link_expired_header: headerText = 'Your Preview Pass Expired',
    previewPass_link_expired_text: text = 'Link your TV Provider to continue watching.',
    previewPass_link_expired_button: buttonText = 'Link my TV Provider',
  } = window.Language;

  return (
    <div className={classNames(sharedTheme.container, Style.container)}>
      <div
        className={classNames(Style.innerContainer, Style.previewPassExpired)}
        style={innerContainerStyle}
      >
        <div className={Style.content}>
          <div className={Style.previewPassExpiredHeading}>{headerText}</div>
          <div className={Style.previewPassExpiredSubheading}>{text}</div>
          <button onClick={openOverlay} className={Style.previewPassButton}>
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  );
};

MVPDSSO.defaultProps = {
  isActive: false,
  openOverlay: null,
  backgroundInline: null,
  sharedTheme: {},
};

MVPDSSO.propTypes = {
  isActive: PropTypes.bool,
  openOverlay: PropTypes.func,
  backgroundInline: PropTypes.shape({}),
  sharedTheme: PropTypes.shape({}),
};

export default MVPDSSO;
